






import moment from 'moment'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

/**
 * 时间组件
 */
@Component
export default class ContDown extends Vue {
  @Prop({ default: '' }) public stime: any
  @Prop() public etime: any
  @Prop({ default: 'countDown' }) public type: string
  private differTime: any = 0

  public mounted() {
    this.calculation(this.etime, this.stime)
  }
  @Watch('etime')
  protected changeTime() {
    this.calculation(this.etime, this.stime)
  }

  protected calculation(etime: any, stime: any) {
    let currentTime = moment(Date.now()).valueOf()
    let timer = Number(moment.duration(etime - currentTime))
    if (this.type === 'countDown') {
      let newTime = setInterval(() => {
        timer = timer * 1 - 1000
        if (timer <= 0) {
          this.$emit('orderTime', timer)
          clearInterval(newTime)
        } else {
          this.getTimer(timer)
        }
      }, 1000)
    } else if (this.type === 'noCountDown') {
      let noCountDownTimer = Number(moment.duration(etime - stime))
      if (noCountDownTimer <= 0) {
        this.differTime = 1 + '天'
        return
      }
      this.getTimer(noCountDownTimer)
    }
  }

  protected getTimer(difference: any) {
    let result = ''
    let newTime = moment.duration(difference)
    let day = newTime.days()
    let hour = newTime.hours()
    let minute = newTime.minutes()
    let mill = newTime.seconds()
    if (this.type === 'countDown') {
      if (day > 0) {
        result += day + '天'
        this.differTime = result
      }
      if (hour > 0) {
        result += hour + '时'
        this.differTime = result
      }
      if (minute >= 0) {
        result += minute + '分'
        this.differTime = result
      }
      if (mill >= 0) {
        result += mill + '秒'
        this.differTime = result
      }
    } else {
      if (day > 0) {
        this.differTime = day * 1 + 1 + '天'
      } else {
        this.differTime = hour + '时'
      }
    }
  }
}
